/**
 * Show More Button komponenta
 * -------------------------
 * Custom element za proširivanje/skupljanje liste stavki u filterima (Color, Size, itd).
 *
 * HTML struktura (facets.liquid):
 *   <details> (filter accordion - Color, Size...)
 *     <summary>...</summary>
 *     <div class="parent-display">  <- sadrži sve
 *       <fieldset class="parent-wrap">
 *         <ul>
 *           <li class="show-more-item">...</li>  <- prve N vidljive
 *           <li class="show-more-item hidden">...</li>  <- skrivene dok se ne klikne Show more
 *         </ul>
 *       </fieldset>
 *       <show-more-button>
 *         <button id="Show-More-X-Y">
 *           <span class="label-show-more label-text">+ Show more</span>
 *           <span class="label-show-less label-text hidden">- Show less</span>
 *         </button>
 *       </show-more-button>
 *     </div>
 *   </details>
 *
 * Logika: Klik na Show more/Show less menja .hidden na .show-more-item elementima.
 */
const LOG_PREFIX = '[ShowMore]';

// Dijagnostika: prati klikove - šta zapravo prima klik?
document.addEventListener(
  'click',
  (e) => {
    const inFacets = e.target.closest('.facets-container, .mobile-facets');
    if (!inFacets) return;
    const topmost = document.elementFromPoint(e.clientX, e.clientY);
    const targetTag = e.target?.tagName;
    const isSummary = e.target.closest('summary');
    const isShowMoreArea = e.target.closest('show-more-button');
    const wantedShowMore = topmost?.closest('show-more-button'); // korisnik je ciljao Show more?
    if (isSummary || isShowMoreArea || wantedShowMore) {
      console.log(LOG_PREFIX, 'DOCUMENT capture', {
        'event.target': targetTag,
        'elementFromPoint': topmost?.tagName,
        'elementFromPoint.id': topmost?.id,
        isSummary: !!isSummary,
        isShowMoreArea: !!isShowMoreArea,
        userClickedShowMoreArea: !!wantedShowMore,
        problem:
          isSummary && wantedShowMore
            ? 'Korisnik je kliknuo Show more ali OVERLAY (summary) je primio klik - z-index bug!'
            : isSummary
              ? 'Klik na summary - normalno'
              : null,
      });
    }
  },
  true
);

if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        if (!button) {
          console.warn(LOG_PREFIX, 'No button found inside show-more-button');
          return;
        }
        console.log(LOG_PREFIX, 'Constructor: attaching click handler to', button.id || button);
        button.addEventListener('click', (event) => {
          console.log(LOG_PREFIX, 'CLICK received', {
            target: event.target,
            targetTag: event.target?.tagName,
            targetId: event.target?.id,
            currentTarget: event.currentTarget?.id,
            defaultPrevented: event.defaultPrevented,
            inDetails: event.target.closest('details')?.id,
          });
          event.stopPropagation();
          this.expandShowMore(event);
          try {
            const parentDisplay = event.target.closest('.parent-display');
            const nextElementToFocus = parentDisplay?.querySelector('.show-more-item:not(.hidden)');
            if (nextElementToFocus?.querySelector('input')) {
              nextElementToFocus.querySelector('input').focus();
            }
          } catch (e) {
            console.warn(LOG_PREFIX, 'Focus logic error:', e);
          }
        });
      }
      expandShowMore(event) {
        const showMoreBtn = event.target.closest('[id^="Show-More-"]');
        const parentDisplay = showMoreBtn?.closest('.parent-display');

        console.log(LOG_PREFIX, 'expandShowMore', {
          showMoreBtn: showMoreBtn?.id,
          parentDisplay: parentDisplay?.id,
          parentDisplayFound: !!parentDisplay,
        });

        if (!parentDisplay) {
          console.error(LOG_PREFIX, 'parentDisplay NOT FOUND - check DOM structure');
          return;
        }

        const items = parentDisplay.querySelectorAll('.show-more-item');
        console.log(LOG_PREFIX, 'show-more-items count:', items.length);

        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        items.forEach((item) => item.classList.toggle('hidden'));

        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }

        console.log(LOG_PREFIX, 'expandShowMore done, hidden count:', parentDisplay.querySelectorAll('.show-more-item.hidden').length);
      }
    }
  );
}